import { ColDef, GridReadyEvent } from 'ag-grid-community'
import dateRenderer from 'components/column-renderers/date'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import { SyntheticEvent, useMemo } from 'react'
import { EAccessCodeOwnership, EAccessCodeOwnershipLabels, OwnedAccessCode } from 'types'

export function UserOrgAccessCodesCell({
  accessCodes,
  showOrgName = false,
  showNumbersOfUsers = true,
  showOwnership = false,
}: {
  accessCodes: OwnedAccessCode[]
  showOrgName?: boolean
  showNumbersOfUsers?: boolean
  /** Only the Administrative Portal → Users → Trainee popup shows it. */
  showOwnership?: boolean
}) {
  const [isOpen, onOpen, onClose] = useShowControl()

  const handleOpen = (event: SyntheticEvent) => {
    event.preventDefault()
    onOpen()
  }

  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit()
  }

  const columnDefs: ColDef[] = useMemo(() => {
    return [
      {
        headerName: 'Access Code',
        field: 'code',
      },
      {
        headerName: 'Organization Name',
        field: 'organizationName',
        hide: !showOrgName,
      },
      {
        headerName: 'Code Ownership',
        field: 'ownership',
        hide: !showOwnership,
        valueGetter: ({ data }) =>
          EAccessCodeOwnershipLabels[
            (data as OwnedAccessCode)?.ownership ?? EAccessCodeOwnership.organizational
          ],
      },
      {
        headerName: 'State',
        field: 'specificState',
      },
      {
        headerName: 'Unit Name',
        field: 'specificUnitName',
      },
      {
        headerName: 'Effective Date',
        cellRenderer: dateRenderer('effectiveDate'),
        colId: 'effectiveDate',
      },
      {
        headerName: 'Expire Date',
        cellRenderer: dateRenderer('expiryDate'),
        colId: 'expiryDate',
      },
      {
        headerName: 'Number of Users',
        field: 'numberOfUsers',
        hide: !showNumbersOfUsers,
      },
    ]
  }, [showOrgName, showNumbersOfUsers, showOwnership])

  return (
    <div>
      <a href="" onClick={handleOpen}>
        {accessCodes.length}
      </a>

      <UIModal isOpen={isOpen} onClose={onClose} width={1188} title="Access Codes">
        <div
          className="ag-theme-alpine"
          style={{ height: '400px', width: '1140px', fontSize: '1rem' }}
        >
          <InfinityAgGrid
            rowData={accessCodes}
            columnDefs={columnDefs}
            rowModelType="clientSide"
            onGridReady={handleGridReady}
            floatingFiltersHeight={0}
          />
        </div>
      </UIModal>
    </div>
  )
}
